var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinManagerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 38.75,
    rx: 5,
    ry: 1.25,
    fill: "#5E656E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6237 17.1767C35.578 7.72618 27.5468 0.231435 18.116 1.36335C11.2947 2.18047 5.65711 7.69939 4.578 14.6449C4.22484 16.9221 4.34256 19.119 4.85268 21.1618C5.57863 24.082 7.27905 26.6539 9.44382 28.6967L20.0976 38.75L30.529 28.7168C33.3282 26.0243 35.2706 22.4344 35.578 18.5162C35.6107 18.0742 35.6303 17.6254 35.6237 17.17V17.1767Z",
    fill: "white",
    stroke: "#2559F6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 26.7486C25.8333 26.7486 28.7486 22.8314 28.7486 17.9993C28.7486 13.1672 25.8333 9.25 19.9993 9.25C14.1653 9.25 11.25 13.1672 11.25 17.9993C11.25 22.8314 14.1653 26.7486 19.9993 26.7486Z",
    fill: "#FCC629"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 14.5625C19.375 15.4524 18.9617 16.2458 18.3165 16.7612C17.8146 16.5928 17.173 16.4375 16.5625 16.4375C15.952 16.4375 15.3104 16.5928 14.8085 16.7612C14.1633 16.2458 13.75 15.4524 13.75 14.5625C13.75 13.0092 15.0092 11.75 16.5625 11.75C18.1158 11.75 19.375 13.0092 19.375 14.5625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 14.5625C26.25 15.4524 25.8367 16.2458 25.1915 16.7612C24.6896 16.5928 24.048 16.4375 23.4375 16.4375C22.827 16.4375 22.1854 16.5928 21.6835 16.7612C21.0383 16.2458 20.625 15.4524 20.625 14.5625C20.625 13.0092 21.8842 11.75 23.4375 11.75C24.9908 11.75 26.25 13.0092 26.25 14.5625Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 16.125C17.9105 16.125 18.75 15.2855 18.75 14.25C18.75 13.2145 17.9105 12.375 16.875 12.375C15.8395 12.375 15 13.2145 15 14.25C15 15.2855 15.8395 16.125 16.875 16.125Z",
    fill: "#16191D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 16.125C24.1605 16.125 25 15.2855 25 14.25C25 13.2145 24.1605 12.375 23.125 12.375C22.0895 12.375 21.25 13.2145 21.25 14.25C21.25 15.2855 22.0895 16.125 23.125 16.125Z",
    fill: "#16191D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.625C14.375 23.625 14.375 18 14.375 18H25.625C25.625 18 25.625 23.625 20 23.625Z",
    fill: "#FF6168"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.3125V18H25V18.3125C25 18.6577 24.7202 18.9375 24.375 18.9375H15.625C15.2798 18.9375 15 18.6577 15 18.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinManagerOff);
export default __webpack_public_path__ + "static/media/icon-pin-manager-off.b6d7df016c570a558ab3fbc3f687cb2c.svg";
export { ForwardRef as ReactComponent };